/* global axios */
import ApiClient from './ApiClient';

class SubscriptionAPI extends ApiClient {
  constructor() {
    super('billing', { accountScoped: true });
  }

  createCheckoutSession(planId = null, extraPayload = {}) {
    const data = planId ? { plan_id: planId, ...extraPayload } : extraPayload;
    return axios.post(`${this.url}/checkout`, data);
  }

  createPortalSession() {
    return axios.post(`${this.url}/portal`);
  }

  createPaymentMethodPortalSession() {
    return axios.post(`${this.url}/portal/payment_method`);
  }

  updateSubscription(planId, extraPayload = {}) {
    const billingPayload = planId
      ? { plan_id: planId, ...extraPayload }
      : { ...extraPayload };
    return axios.post(`${this.url}/update`, { billing: billingPayload });
  }

  cancelSubscription() {
    return axios.post(`${this.url}/cancel`);
  }

  fetchPrices() {
    return axios.get(`${this.url}/prices`);
  }
}

export default new SubscriptionAPI();
